import React from "react";
import { AiFillHome } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { HiOutlineLanguage } from "react-icons/hi2";
import { Link } from "react-router-dom";

function Bottombar({ activeBar }) {
  return (
    <div className=" flex justify-between rounded-tl-none rounded-tr-none rounded-bl-lg rounded-br-lg  py-2  fixed bottom-1 sm:hidden px-5  bg-[#2A71E8] mt-5 items-center h-[70px] w-full">
      <Link to="/">
        {" "}
        <AiFillHome color={activeBar === "home" ? "#BE2117" : "white"} size={35} />
      </Link>
      <Link to="/input">
        {" "}
        <HiOutlineLanguage  color={activeBar === "input" ? "#BE2117" : "white"} size={35} />
      </Link>
      <Link to="/settings">
        {" "}
        <BsFillPersonFill color={activeBar === "settings" ? "#BE2117" : "white"} size={35} />
      </Link>
    </div>
  );
}

export default Bottombar;
